import { useNotifications } from '@revenuewell/uc-notifications-client';
import { useOidcWithAdmin } from 'libs/logic/oidc/src/hooks/use-oidc-with-admin-intercept';
import { useEffect } from 'react';

export const TerminateAuthSessionListener = () => {
  const { listen } = useNotifications();
  const { logoutRedirect, getClaims } = useOidcWithAdmin();

  useEffect(() => {
    const terminateAuthSessionListener = listen('terminate-auth-session', async (event) => {
      const { customeruserid } = event as any;
      const claims = await getClaims();

      if (claims?.id == customeruserid) {
        logoutRedirect();
      }
    });

    return () => terminateAuthSessionListener();
  }, []);

  return null;
};
